import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class BookGetTagsArgs {
  @Field(t => Int, { nullable: true })
  categoryId?: number

  @Field({ nullable: true })
  searchValue?: string

  @Field(t => Int, { nullable: true })
  take?: number

  @Field(t => Int, { nullable: true })
  skip?: number
}
